module.exports = {"659002001":"金银川路街道","659002002":"幸福路街道","659002003":"青松路街道","659002004":"南口街道","659002200":"托喀依乡","659002402":"工业园区","659002500":"兵团七团","659002501":"兵团八团","659002503":"兵团十团","659002504":"兵团十一团","659002505":"兵团十二团","659002506":"兵团十三团","659002507":"兵团十四团","659002509":"兵团十六团","659002510":"兵团九团","659002511":"兵团第一师水利水电工程处","659002512":"兵团第一师塔里木灌区水利管理处","659002516":"兵团一团","659002517":"兵团农一师沙井子水利管理处","659002518":"西工业园区管理委员会","659002519":"兵团二团","659002520":"兵团三团","659002521":"兵团五团","659002522":"兵团六团","659002523":"兵团四团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659002.json
// module id = 3151
// module chunks = 0